import { useEffect, useState } from 'react';
import { getComecoAno, getDataSeteDiasAntesFormatado, getHojeFormatado, getMesAtual, getMesPassado, ultimoDiaMesPassado } from "../../../utils/formatDate";
import { Loading } from "../../../componentes/loading/loading";
import DropDown from "../../../componentes/dropdown/dropdown";
import Button from "../../../componentes/button/button";
import { toast } from 'react-toastify';
import FortesFinanceiroService from "../../../services/resource/fortesFinanceiroService";
import ContasPagarDashboard from "./dashboard";
import { intervaloDatas } from '../../../utils/options';
import { TabelaContasPagar } from './TabelaContasPagar';
import Input from '../../../componentes/input/input';

export default function ContasPagar() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDashboard, setShowDashboard] = useState(true);
  const [loadingExportacao, setLoadingExportacao] = useState(false);
  const [empresas, setEmpresas] = useState([])
  const [codigoEmpresa, setCodigoEmpresa] = useState("0002");
  const [filtro, setFiltro] = useState(false);
  const [filtrarDashboard, setFiltrarDashboard] = useState(0);
  const [dataInicial, setDataInicial] = useState(getMesAtual());
  const [dataFinal, setDataFinal] = useState(getHojeFormatado());
  const [dataSelecionada, setDataSelecionada] = useState(7);
  const service = new FortesFinanceiroService();
  const FileDownload = require('js-file-download');

  const mudarPeriodoDeDatas = (e) => {
    const valor = e.target.value;
    setDataSelecionada(valor);
    if (valor === 14) {
      setFiltro(true);  // abre o filtro
    } else if (valor === 7) {
      setDataInicial(getMesAtual());
      setDataFinal(getHojeFormatado());
      setFiltro(false);
    } else if (valor === 30) {
      setDataInicial(getMesPassado());
      setDataFinal(ultimoDiaMesPassado());
      setFiltro(false);
    } else if (valor === 365) {
      setDataInicial(getComecoAno());
      setDataFinal(getHojeFormatado());
      setFiltro(false);

    } else {
      setFiltro(false);
      setDataInicial(getDataSeteDiasAntesFormatado(valor));
    }
 
    showDashboard ? atualizarDashboard() : listarContasPagar()
  }

  const listarContasPagar = async () => {
    setLoading(true)
    service.listaContasPagar({
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      codigoEmpresa: codigoEmpresa
    }).then(response => {
      setDados(response.data);
      if (response.data.length <= 0) toast.warning("Sem registros para o filtro informado!");
    }).catch(error => {
      console.error(error)
      console.error('Erro ao realizar consulta: ', error)
    }).finally(() => {
      setTimeout(() => setLoading(false), 400);
    });
  };

  const exportDespesas = () => {
    setLoadingExportacao(true)
    service.exportarDespesaExcel({
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      codigoEmpresa: codigoEmpresa
    }).then(response => {
      const date = new Date();
      FileDownload(response.data, "Contas a Pagar " + date.getTime() + ".xlsx");
      setTimeout(() => setLoadingExportacao(false), 400);
    }).catch(error => {
      console.error(error)
      console.error(error.message);
      setTimeout(() => setLoadingExportacao(false), 400);
    })
  }

  const atualizarDashboard = () => {
    var soma = filtrarDashboard + 1;
    setFiltrarDashboard(soma)
  }

  const alteraVisao = () => {
    if (showDashboard) {
      listarContasPagar()
    } else {
    }
    setShowDashboard(!showDashboard)
  }

  return (
    <div className="w-full p-6">
      <div className="bg-card border border-border rounded-lg shadow-card p-4 mb-6">
        <div className="flex flex-wrap items-end gap-3 justify-between">
          <div className="flex flex-wrap items-end gap-3 flex-1 min-w-[280px]">
            <div className="w-full sm:w-60">
              <DropDown
                optional
                options={intervaloDatas}
                label="Período"
                optionLabel="label"
                optionValue="value"
                filter={false}
                value={dataSelecionada}
                onChange={mudarPeriodoDeDatas}
              />
            </div>

            {filtro && (
              <div className="w-full sm:w-44">
                <Input
                  label="Data Inicial"
                  type="date"
                  onChange={(e) => setDataInicial(e.target.value)}
                  className="h-10 px-0 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary w-full"
                  value={dataInicial}
                />
              </div>
            )}

            {filtro && (
              <div className="w-full sm:w-44">
                <Input
                  label="Data Final"
                  type="date"
                  className="h-10 px-0 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary w-full"
                  onChange={(e) => setDataFinal(e.target.value)}
                  value={dataFinal}
                />
              </div>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 items-end justify-end flex-none">
            <div className="flex gap-3">
              <Button
                onClick={alteraVisao}
                iconLeft={showDashboard ? "fas fa-list" : "fas fa-pie-chart"}
                title={showDashboard ? "Exibir Lista" : "Exibir Dashboard"}
                label={showDashboard ? "Exibir Lista" : "Exibir Dashboard"}
                disabled={loading}
              />
              <Button
                onClick={exportDespesas}
                variant="green"
                iconLeft="fas fa-file-excel"
                title="Exportar Planilha"
                label="Exportar Planilha"
                loading={loadingExportacao}
                disabled={loadingExportacao || loading}
              />
            </div>
          </div>
        </div>
      </div>

      {showDashboard ?
        <ContasPagarDashboard
          dataFinal={dataFinal}
          dataInicial={dataInicial}
          codigoEmpresa={codigoEmpresa}
          filtrar={filtrarDashboard}
          setLoad={(value) => setLoading(value)}
        />
        :
        <div className="bg-card border border-border rounded-xl shadow-soft ">
          <div className="p-6 border-b border-border">
            <div className="flex justify-between items-center">
              <div className="col-10 flex items-center">
                <div className="bg-primary/10 p-3 rounded-lg mr-4">
                  <i className="fas fa-balance-scale text-primary text-xl"></i>
                </div>
                <div>
                  <h2 className="text-xl font-display font-bold text-foreground">Prestação de Contas a Pagar</h2>
                  <p className="text-muted-foreground">Relatório detalhado de Contas a Pagar</p>
                </div>
              </div>
              <div className="col-2">
                <div className="text-right">
                  <p className="text-sm text-muted-foreground mb-1">Total de registros</p>
                  <p className="text-2xl font-display font-bold text-primary">{loading ? "" : dados.length}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="pb-4">
            {loading ?
              <Loading />
              :
              <TabelaContasPagar dados={dados} />
            }
          </div>
        </div>
      }
    </div>
  );
}